<template>
  <div>
    <div id="topHeader">
      <!-- 菜单区域 -->
      <div class="menu">
        <div @click="handleMenu(-1)">设备管理成熟度评估系统</div>
      </div>
      <!-- 登录区域 -->
      <div class="rightArea" ref="headerRight">
        <!-- 登录成功 -->
        <div class="succesUser">
          <navMenu-Login @chang="handleMenu"></navMenu-Login>
        </div>
      </div>
    </div>
    <!-- 清除固定定位带来影响 -->
    <div style="width: 100%; height: 60px"></div>
  </div>
</template>

<script>
import navMenuLogin from './NavMenu_login.vue';
export default {
  name: 'Header',
  data() {
    return {
      userData: { data: {} }, // 登录用户信息
    };
  },
  props: ['menuList'],
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  created() {
    this.getUserinfo(this.currentUser);
  },
  mounted() {},
  watch: {
    currentUser(e) {
      this.getUserinfo(e);
    },
  },
  methods: {
    // 处理用户信息
    getUserinfo(data) {
      if (!data) return;
      this.userData.data = data;
    },
    handleMenu(val) {
      // 首页跳转
      if (val == -1) {
        this.$emit('changeMenu', 'home');
        this.$router.push({
          path: '/homePage',
        });
      } else {
        //账号下拉菜单跳转
        let current_menu = this.menuList.filter((item) => {
          return item.url.indexOf(val) > 0;
        });
        if (current_menu&&current_menu.length) {
          this.$emit('changeMenu', current_menu[0].id);
        } else {
          this.$emit('changeMenu');
        }
        switch (val) {
          case 'accountCenter': // 账号信息管理
            this.$router.push({
              path: '/accountPages/accountCenter',
            });
            break;
          case 'expertManage': //专家库管理
            this.$router.push({
              path: '/accountPages/expertManage',
            });
            break;
          case 'accountManage': //注册审批管理
            this.$router.push({
              path: '/accountPages/accountManage',
            });
            break; //
          case 'orgManage': //用户组织管理
            this.$router.push({
              path: '/accountPages/orgManage',
            });
            break;
          case 'changeAccount': //切换账号
            this.logOut();
            break;
          case 'logOut': //退出
            this.logOut();
            break;
        }
      }
      this.$store.state.menuName = val;
    },
    // 退出
    logOut() {
      this.$axios
        .post(`${process.env.BASE_URL}api/login/logout`)
        .then((res) => {
          if (res.data.code === 200) {
            localStorage.clear();
            sessionStorage.clear();
            this.userData.data = {};
            window.document.cookie = 'token=';
            window.document.cookie = 'userInfo=';
            //存储当前模块的首页，用于退出到登录页，登录后跳转至此
            const t = new Date();
            t.setTime(t.getTime() + 24 * 60 * 60 * 1000 * 7);
            this.$router.push({ path: '/' });
            this.clearVuex();
          } else {
            this.$message({
              type: 'error',
              message: '退出失败-' + res.data.msg,
              offset: 80,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clearVuex() {
      this.$store.dispatch('setCurrentUserFun', null);
      // Object.keys(this.$store.state).forEach((e) => {
      //   if (e != 'appTypes' && e != 'industryTypes' && e != 'areaTypes' && e != 'resourcesType') {
      //     console.info(e);
      //     let option = 'set' + e.charAt(0).toUpperCase() + e.slice(1) + 'Fun';
      //     this.$store.dispatch(option, null);
      //   }
      // });
    },
  },

  components: {
    navMenuLogin,
  },
};
</script>

<style lang="less" scoped>
#topHeader {
  height: 60px;
  width: 100%;
  // color: #fff;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  // background-color: rgb(55, 65, 81);
  box-shadow: 0px 0px 6px rgba(67, 104, 130, 0.1);
  backdrop-filter: blur(8px);
  z-index: 1999;
  position: fixed;
}

// 菜单 区域
.menu {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  height: 100%;
  cursor: pointer;
  font-weight: 600;

  img {
    cursor: pointer;
    margin-right: 60px;
  }
}

// 登录 区域
.rightArea {
  display: flex;
  align-items: center;
  color: @header_color;
  font-weight: 600;
  height: 100%;

  .vertical {
    width: 1px;
    height: 18px;
    background-color: @header_color;
    margin: 0 20px;
  }

  .devel {
    margin-right: 22px;
  }

  .eperience {
    margin-left: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;

    p {
      cursor: pointer;
    }

    .register {
      background: #3e83b8;
      border-radius: 1px;
      width: 51px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      color: #fff;
    }
  }
}

// 登录成功
.succesUser {
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
}
</style>

<style>
#topHeader .rightArea .el-input__inner {
  height: 28px;
  background: #f1f2f5;
  border: none;
}
</style>
<!-- 移动端代码 -->
<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {

}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  #topHeader{
    padding: 0 20px;
    .menu{
      margin-left: 55px;
    }
  }
}
</style>